"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shape = {
  borderRadius: 4
};
var _default = shape;
exports.default = _default;


// WEBPACK FOOTER //
// ./~/@material-ui/core/styles/shape.js